import { NameDto } from 'api/Common/Types'

export type ReferralMaterialsUrls = {
  baseUrlType: NameDto
  targetUrl: string
  isActive: boolean
}[]

export interface ReferralMaterialsCategoriesDto {
  enabled: boolean
  endDateTime: string | null
  id: string
  isActive: boolean
  name: string
  alias: string
  tickmillCompany: NameDto
  updatedDate: string
  urls: ReferralMaterialsUrls
}

export interface ReferralMaterialsDto {
  id: string
  name: string
  type: NameDto | null
  categories: (NameDto<string> & { isActive: boolean })[] | null
  sizes: NameDto[]
  targetUrls: ReferralMaterialsUrls
  caLanguages: NameDto<string>[]
  tickmillCompany: NameDto
  enabled: boolean
  endDateTime: string | null
  updatedDateTime: string
  activePromoAssetsLanguages: NameDto<string>[]
}

export interface UpdateReferralMaterialDto {
  name: string
  tickmillCompanyId: number
  typeId: number
  categoryIds: string[]
  endDateTime: string | null
  enabled: boolean
  caLanguages: string[]
  deactivatePromoAssets?: boolean
}

export interface UpdateReferralMaterialCategoryDto {
  name: string
  alias: string
  tickmillCompanyId: number
  endDateTime: string | null
  enabled: boolean
  urls: { baseUrlTypeId?: number; targetUrl?: string }[]
}

export enum ReferralMaterialsPageKey {
  name = 'name',
  type = 'type',
  categories = 'categories',
  sizes = 'sizes',
  path = 'url',
  language = 'caLanguages.name',
  entity = 'tickmillCompany.name',
  active = 'tickmillCompany.enabled',
  endDate = 'endDateTime',
  updatedDate = 'updatedDate',
}

export enum ReferralMaterialsPageFilterKey {
  name = 'Name',
  enabled = 'Enabled',
  type = 'TypeId',
  promoMaterialContentType = 'PromoMaterialContentTypeId',
  caLanguageId = 'CaLanguageId',
  promoAssets = 'PromoAssets',
  endDateTime = 'EndDateTime',
  dateUpdated = 'DateUpdated',
  dateTimeUpdated = 'DateTimeUpdated',
}

export enum ReferralMaterialsCategoriesPageKey {
  name = 'name',
  urls = 'urls',
  entity = 'tickmillCompany.name',
  active = 'tickmillCompany.enabled',
  endDate = 'endDateTime',
  updatedDate = 'updatedDate',
}

export enum ReferralMaterialsCategoriesPageFilterKey {
  name = 'Name',
  tickmillCompanyId = 'TickmillCompanyId',
  enabled = 'Enabled',
  isActive = 'IsActive',
  targetUrl = 'Url',
  baseUrl = 'BaseUrl',
  endDateTime = 'EndDateTime',
  dateUpdated = 'DateUpdated',
  dateTimeUpdated = 'DateTimeUpdated',
}
